import React from 'react';

import HtmlContent from 'components/HtmlContent';
import { HtmlContentProps } from 'components/HtmlContent/types';

import { content } from './styles';

const LawyerDocument: React.FC<HtmlContentProps> = props => {
  return <HtmlContent {...props} customCSS={content} />;
};

export default LawyerDocument;
